var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"layer-glyph",style:(_vm.glyphStyle),domProps:{"innerHTML":_vm._s(_vm.markup)}})
}
var staticRenderFns = []

export { render, staticRenderFns }